import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UpcomingClasses = ({ classes, onViewAll, onCancelClass }) => {
  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date?.toLocaleTimeString('en-US', { 
      hour: 'numeric', 
      minute: '2-digit',
      hour12: true 
    });
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow?.setDate(tomorrow?.getDate() + 1);

    if (date?.toDateString() === today?.toDateString()) return 'Today';
    if (date?.toDateString() === tomorrow?.toDateString()) return 'Tomorrow';
    
    return date?.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const getTimeUntilClass = (dateString) => {
    const classTime = new Date(dateString);
    const now = new Date();
    const diffMinutes = Math.floor((classTime - now) / (1000 * 60));
    
    if (diffMinutes < 60) return `Starts in ${diffMinutes}m`;
    if (diffMinutes < 1440) return `Starts in ${Math.floor(diffMinutes / 60)}h`;
    return null;
  };

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Calendar" size={20} color="var(--color-primary)" />
          </div>
          <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
            Upcoming Classes
          </h2>
        </div>
        <Button
          variant="ghost"
          size="sm"
          iconName="ArrowRight"
          iconPosition="right"
          onClick={onViewAll}
        >
          View All
        </Button>
      </div>
      {classes?.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-12">
          <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
            <Icon name="Calendar" size={32} color="var(--color-muted-foreground)" />
          </div>
          <p className="text-sm text-muted-foreground text-center mb-4">
            No upcoming classes booked
          </p>
          <Button variant="outline" iconName="Plus" iconPosition="left" onClick={onViewAll}>
            Book a Class
          </Button>
        </div>
      ) : (
        <div className="space-y-4">
          {classes?.map((classItem) => {
            const timeUntil = getTimeUntilClass(classItem?.startTime);
            
            return (
              <div
                key={classItem?.id}
                className="flex flex-col md:flex-row gap-4 p-4 rounded-lg border border-border hover:border-primary/50 transition-all duration-250"
              >
                <div className="flex-shrink-0">
                  <div className="w-full md:w-20 h-32 md:h-20 rounded-lg overflow-hidden">
                    <Image
                      src={classItem?.image}
                      alt={classItem?.imageAlt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-2 mb-2">
                    <div>
                      <h3 className="text-base md:text-lg font-medium text-foreground mb-1">
                        {classItem?.name}
                      </h3>
                      <div className="flex flex-wrap items-center gap-3 text-sm text-muted-foreground">
                        <span className="flex items-center gap-1">
                          <Icon name="User" size={14} />
                          {classItem?.trainer}
                        </span>
                        <span className="flex items-center gap-1">
                          <Icon name="MapPin" size={14} />
                          {classItem?.location}
                        </span>
                      </div>
                    </div>
                    
                    {timeUntil && (
                      <span className="badge-warning whitespace-nowrap">
                        {timeUntil}
                      </span>
                    )}
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="flex items-center gap-4 text-sm">
                      <span className="flex items-center gap-1 text-foreground font-medium">
                        <Icon name="Calendar" size={14} />
                        {formatDate(classItem?.startTime)}
                      </span>
                      <span className="flex items-center gap-1 text-foreground font-medium">
                        <Icon name="Clock" size={14} />
                        {formatTime(classItem?.startTime)}
                      </span>
                      <span className="flex items-center gap-1 text-muted-foreground">
                        <Icon name="Users" size={14} />
                        {classItem?.spotsLeft} spots left
                      </span>
                    </div>

                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="X"
                      onClick={() => onCancelClass(classItem?.id)}
                      className="text-error hover:text-error hover:bg-error/10"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UpcomingClasses;